// extracted by mini-css-extract-plugin
export var standaloneTable = "_eo-0";
export var withExtraHeader = "_eo-1";